export const generateCampaignEmbedForm = (id) => {
  return `
    <!-- Begin Spark Campaign Letter Form -->
    <div id="spark-letter-writing" data-id="${id}"></div>
    <script src="${process.env.REACT_APP_WP_DOMAIN}/dist/spark-letter-writing.js"></script>
    <!-- End Spark Campaign Letter Form -->
  `
};
